import PageLayout from "../../../_components/PageLayout";
import MyButton from "../../../_components/MyButton";
import { Box, Stack, useTheme } from "@mui/material";
import { useSwiper } from "swiper/react";
import OrbitingLogos from "../components/OrbitingLogos/OrbitingLogos";
import Text from "../../../_components/Text";

const ConnectAccount = () => {
  const theme = useTheme();

  const swiper = useSwiper();
  const handleSlideNext = () => swiper.slideNext();

  return (
    <PageLayout
      bottomButton={
        <MyButton withPaper onClick={handleSlideNext}>
          Next
        </MyButton>
      }
    >
      <Box
        className="layout"
        sx={{
          backgroundColor: theme.myTheme.colors.bg,
          padding: "0 8px 16px",
        }}
      >
        <OrbitingLogos marginBottom="32px" />

        <Stack>
          <Text textAlign="center" variant="h2" mb="24px">
            Connect your exchange account
          </Text>
          <Text textAlign="center" variant="regular" mb="8px">
            To trade, connect an exchange account: Binance, Bybit, OKX, BingX, MEXC.
          </Text>
          <Text textAlign="center" variant="regular">
            You can connect an exchange anytime.
          </Text>
        </Stack>
      </Box>
    </PageLayout>
  );
};

export default ConnectAccount;
